import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppState } from '@app/reducers';
import {
  CrudType,
  IApplicationResponse, LoggedInUserModel,
  ModulesBasedApiSuffix, PERMISSION_RESTRICTION_ERROR,
  RxjsService, SnackbarService,
  addDefaultTableObjectProperties,
  currentComponentPageBasedPermissionsSelector$,
  onActionSubmittedUtil,
  prepareDynamicTableTabsFromPermissions, prepareGetRequestHttpParams
} from '@app/shared';
import { CrudService } from '@app/shared/services';
import { MY_TASK_COMPONENT } from '@modules/my-tasks/shared';
import { loggedInUserData } from '@modules/others';
import { SalesModuleApiSuffixModels } from '@modules/sales';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs/internal/observable/combineLatest';
import { take } from 'rxjs/operators';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
@Component({
  selector: 'boundary-approver-dashboard',
  templateUrl: './boundary-approver-dashboard.component.html'
})
export class BoundaryApproverDashboardComponent extends PrimeNgTableVariablesModel implements OnInit {
  constructor(private rxjsService: RxjsService, private store: Store<AppState>, private router: Router,
    private crudService: CrudService, private snackbarService: SnackbarService) {
    super();
    this.primengTableConfigProperties = {
      tableCaption: "Approval Boundary Dashboard",
      breadCrumbItems: [{ displayName: 'My Tasks', relativeRouterUrl: '' }, { displayName: 'Boundary Management' }, { displayName: 'Approval Boundary Dashboard' }],
      selectedTabIndex: 0,
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'Approval Boundary Dashboard',
            dataKey: 'boundaryRequestId',
            columns: [
              { field: 'boundaryRequestRefNo', header: 'Request ID' },
              { field: 'boundaryName', header: 'Boundary Name' },
              { field: 'createdDate', header: 'Date And Time', isDateTime: true },
              { field: 'boundaryTypeName', header: 'Boundary Type' },
              { field: 'divisionName', header: 'Division' },
              { field: 'districtName', header: 'District' },
              { field: 'boundaryStatusName', header: 'Status' }
            ],
            apiSuffixModel: SalesModuleApiSuffixModels.BOUNDARY_APPROVALS,
            moduleName: ModulesBasedApiSuffix.SALES
          },
        ]
      }
    }
    this.primengTableConfigProperties = addDefaultTableObjectProperties(this.primengTableConfigProperties, [{ index: 0, propertyName: 'enableAddActionBtn' }]);
  }

  ngOnInit() {
    this.combineLatestNgrxStoreData();
    this.onCRUDRequested('get');
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(loggedInUserData),
      this.store.select(currentComponentPageBasedPermissionsSelector$),]
    ).pipe(take(1)).subscribe((response) => {
      if (!response) return;
      this.loggedInUserData = new LoggedInUserModel(response[0]);
      if (response[1][MY_TASK_COMPONENT.BOUNDARY_MGMT_APPROVAL_DASHBOARD]) {
        let prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(this.primengTableConfigProperties, response[1][MY_TASK_COMPONENT.BOUNDARY_MGMT_APPROVAL_DASHBOARD]);
        this.primengTableConfigProperties = prepareDynamicTableTabsFromPermissionsObj['primengTableConfigProperties'];
      }
    });
  }

  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }
  onCRUDRequested(type: CrudType | string, row?: object | any, unknownVar?: any): void {
    switch (type) {
      case CrudType.GET:
        this.row = row ? row : { pageIndex: 0, pageSize: 10 };
        this.first = row?.pageIndex && row?.pageSize ? row["pageIndex"] * row["pageSize"] : 0;
        this.getTableListData(this.row["pageIndex"], this.row["pageSize"], unknownVar);
        break;
      case CrudType.VIEW:
        this.openAddEditPage(CrudType.VIEW, row);
        break;
    }
  }

  openAddEditPage(type: CrudType | string, editableObject?: object | string, index?: number): void {
    switch (type) {
      case CrudType.VIEW:
        if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[0].canEdit) {
          this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR);
        } else if (this.primengTableConfigProperties.tableComponentConfigs.tabsList[0].canEdit) {
          this.router.navigate([`/my-tasks/boundary-management/approval-dashboard/add-edit`], {
            queryParams: {
              boundaryRequestId: editableObject['boundaryRequestId'],
              boundaryRequestRefNo: editableObject['boundaryRequestRefNo'],
              fromUrl: 'DOAApprovalDashboard',
              regionId: editableObject['regionId'],
              layerId: editableObject['boundaryLayerId']
            }
          });
        }
        break;
    }
  }

  getTableListData(pageIndex?: string, pageSize?: string, otherParams?: object) {
    this.loading = true;
    otherParams = { employeeId: this.loggedInUserData?.employeeId, ...otherParams, }
    let salesModuleApiSuffixModels: SalesModuleApiSuffixModels;
    let module = this.primengTableConfigProperties?.tableComponentConfigs?.tabsList[this.selectedTabIndex]?.moduleName
    salesModuleApiSuffixModels = this.primengTableConfigProperties?.tableComponentConfigs?.tabsList[this.selectedTabIndex]?.apiSuffixModel;
    this.crudService.get(module, salesModuleApiSuffixModels, undefined,
      false, prepareGetRequestHttpParams(pageIndex, pageSize, otherParams))
      .subscribe((response: IApplicationResponse) => {
        if (response.statusCode == 200 && response.isSuccess) {
          this.dataList = response.resources;
          this.totalRecords = response.totalCount;
        } else {
          this.dataList = null;
          this.totalRecords = 0;
        }
        this.reset = false;
        this.loading = false;
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }
}
